export default {
  cellphone: /^1[34578]\d{9}$/,
  captcha: /^\d{6}$/,
  email: /^.+@.+\..{2,6}$/,
  projectName: /\S/           // 项目名称重命名不能为空字符串
}



// WEBPACK FOOTER //
// ./src/config/regexes.js